export const BUILDER_ELEMENT_SOCIAL = [
  {
    enable: true,
    name: "Facebook",
    icon: "FacebookIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "Twitter",
    icon: "TwitterIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "Instagram",
    icon: "InstagramIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "Linkedin",
    icon: "LinkedinIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "Youtube",
    icon: "YoutubeIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "TikTok",
    icon: "TikTokIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "WhatsApp",
    icon: "WhatsAppIcon",
    url: "",
    color: ""
  },
  {
    enable: true,
    name: "Web",
    icon: "WebIcon",
    url: "",
    color: ""
  },
];

export const COMPONENT_NAME_MAP = {
  Text: "MailTextModule",
  Image: "MailImageModule",
  Video: "MailVideoModule",
  Button: "MailButtonModule",
  Logo: "MailImageModule",
  Social: "MailSocialModule",
  Html: "MailHtmlModule",
  Divider: "MailDividerModule",
  Link: "MailTextModule",
  Spacer: "MailSpacerModule",
};

export const BUILDER_ELEMENTS = [
  {
    id: 0,
    name: "Título",
    icon: "TitleIcon",
    type: "Text",
    component: "MailTextModule",
    tag: "h1",
    stylesContainer: {},
    styles: {},
    content: "<h1> Título </h1>",
    attributes: {},
  },
  {
    id: 1,
    name: "Texto",
    icon: "TextIcon",
    type: "Text",
    component: "MailTextModule",
    tag: "p",
    stylesContainer: {},
    styles: { "font-size": "1rem" },
    content: "<p>Texto</p>",
    attributes: {},
  },
  {
    id: 2,
    name: "Imagen",
    icon: "ImageIcon",
    type: "Image",
    component: "MailImageModule",
    tag: "img",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      "min-width": "100px",
      'max-width': '100%'
    },
    content: "",
    attributes: {
      alt: "Imagen",
      "img-link": "",
    },
  },
  {
    id: 3,
    name: "Video",
    icon: "VideoIcon",
    type: "Video",
    component: "MailVideoModule",
    tag: "video",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      "min-width": "100px",
      'max-width': '100%'
    },
    content: "",
    attributes: {},
  },
  {
    id: 4,
    name: "Botón",
    icon: "ButtonIcon",
    type: "Button",
    component: "MailButtonModule",
    tag: "a",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      "border-radius": "1rem",
      padding: "0.5rem 1rem",
      display: "inline-block",
      cursor: "pointer",
      userSelect: "none",
      textDecoration: "none",
    },
    content: {
      link: "",
      text: "Botón",
    },
    attributes: {},
  },
  {
    id: 5,
    name: "Logotipo",
    icon: "LogoIcon",
    type: "Image",
    component: "MailImageModule",
    tag: "img",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      'max-width': '100%',
      height: "48px",
      width: "auto"
    },
    content: "",
    attributes: {},
  },
  {
    id: 6,
    name: "Social",
    icon: "SocialIcon",
    type: "Social",
    component: "MailSocialModule",
    tag: "div",
    stylesContainer: {
      display: "grid",
      "grid-template-columns": "1fr 1fr 1fr 1fr",
      gap: "1rem",
      "justify-content": "center",
      "align-items": "center",
    },
    styles: {
      "font-size": "1rem",
      textAlign: "center"
    },
    content: BUILDER_ELEMENT_SOCIAL,
    attributes: {},
  },
  {
    id: 7,
    name: "HTML",
    icon: "HtmlIcon",
    type: "Html",
    component: "MailHtmlModule",
    tag: "div",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      'max-width': '100%'
    },
    content: "<p>HTML</p>",
    attributes: {},
  },
  {
    id: 8,
    name: "Divisor",
    icon: "DividerIcon",
    type: "Divider",
    component: "MailDividerModule",
    tag: "hr",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      border: "none",
      "border-top": "1px solid #000000",
      margin: "1rem 0",
    },
    content: "",
    attributes: {},
  },
  {
    id: 9,
    name: "Link",
    icon: "LinkIcon",
    type: "Button",
    component: "MailButtonModule",
    tag: "a",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      padding: "",
      display: "inline-block",
      cursor: "pointer",
      userSelect: "none",
      textDecoration: "underline",
    },
    content: {
      link: "",
      text: "Link",
    },
    attributes: {},
  },
  {
    id: 10,
    name: "Espaciador",
    icon: "SpacerIcon",
    type: "Spacer",
    component: "MailSpacerModule",
    tag: "div",
    stylesContainer: {},
    styles: {
      "font-size": "1rem",
      height: "1.5rem",
      width: "100%",
      "background-color": "transparent",
    },
    content: "",
    attributes: {},
  },
];



const buildSvgIcon = (iconClass, paths) => (color = "currentColor") => `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline ${iconClass}">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  ${paths.join("\n  ")}
</svg>`;

const SOCIAL_SVG_PATHS = {
  Facebook: {
    iconClass: "icon-tabler-brand-facebook",
    paths: [
      '<path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />',
    ],
  },
  Twitter: {
    iconClass: "icon-tabler-brand-x",
    paths: [
      '<path d="M4 4l11.733 16h4.267l-11.733 -16z" />',
      '<path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />',
    ],
  },
  Instagram: {
    iconClass: "icon-tabler-brand-instagram",
    paths: [
      '<path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />',
      '<path d="M8 11a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />',
      '<path d="M17.5 6.5v.01" />',
    ],
  },
  Linkedin: {
    iconClass: "icon-tabler-brand-linkedin",
    paths: [
      '<path d="M8 11v5" />',
      '<path d="M8 8v.01" />',
      '<path d="M12 16v-5" />',
      '<path d="M16 16v-3a2 2 0 1 0 -4 0" />',
      '<path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z" />',
    ],
  },
  Youtube: {
    iconClass: "icon-tabler-brand-youtube",
    paths: [
      '<path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z" />',
      '<path d="M10 9l5 3l-5 3z" />',
    ],
  },
  TikTok: {
    iconClass: "icon-tabler-brand-tiktok",
    paths: [
      '<path d="M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z" />',
    ],
  },
  WhatsApp: {
    iconClass: "icon-tabler-brand-whatsapp",
    paths: [
      '<path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />',
      '<path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />',
    ],
  },
  Web: {
    iconClass: "icon-tabler-world",
    paths: [
      '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />',
      '<path d="M3.6 9h16.8" />',
      '<path d="M3.6 15h16.8" />',
      '<path d="M11.5 3a17 17 0 0 0 0 18" />',
      '<path d="M12.5 3a17 17 0 0 1 0 18" />',
    ],
  },
};

export const svg = Object.fromEntries(
  Object.entries(SOCIAL_SVG_PATHS).map(([name, { iconClass, paths }]) => [
    name,
    buildSvgIcon(iconClass, paths),
  ]),
);